/* eslint-disable array-bracket-newline */
import { ECEXExchangeName } from '../../../../../reducers/cex_trading';

import binanceIcon from '../../../../../assets/images/exchanges/binance.svg';
import gateIcon from '../../../../../assets/images/exchanges/gateio.svg';
import bybitIcon from '../../../../../assets/images/exchanges/bybit_small.png';

type ExchangeData = { label: string; value: ECEXExchangeName; icon: string };

const binance = {
  label: 'Binance',
  value: ECEXExchangeName.binance,
  icon: binanceIcon,
};

const gate = {
  label: 'Gateio',
  value: ECEXExchangeName.gate,
  icon: gateIcon,
};

const bybit = {
  label: 'Bybit',
  value: ECEXExchangeName.bybit,
  icon: bybitIcon,
};

const EXCHANGE_MAPPING: Record<string, ExchangeData> = {
  [ECEXExchangeName.binance]: binance,
  [ECEXExchangeName.gate]: gate,
  [ECEXExchangeName.bybit]: bybit,
};

const AVAILABLE_EXCHANGES = [binance, gate, bybit];

export { EXCHANGE_MAPPING, AVAILABLE_EXCHANGES };
